import React from 'react';

import { A11Y_CLICK_KEYS_MAP, mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/netcredit.scss';

type OmittedAnchorPropsT =
  | 'href'
  | 'role'
  | 'tabIndex'
  | 'onKeyDown'
  ;

type AnchorWithoutOmittedPropsT = Omit<React.ComponentPropsWithoutRef<'a'>, OmittedAnchorPropsT>;

export type NcButtonStyledAsLinkPropsT = AnchorWithoutOmittedPropsT;

export const NcButtonStyledAsLink = ({
  children,
  className,
  ...rest
}: NcButtonStyledAsLinkPropsT) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>): void => {
    if (![A11Y_CLICK_KEYS_MAP.SPACE, A11Y_CLICK_KEYS_MAP.ENTER].includes(event.key)) { return; }

    event.preventDefault();
    event.currentTarget.click();
  };

  return (
    // This trigger opens disclosure modal content and must wrap like inline link text.
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      {...rest}
      role="button"
      tabIndex={0}
      className={mergeClassNameStrings('as-link', className)}
      onKeyDown={onKeyDown}
    >
      {children}
    </a>
  );
};
